__webpack_require__.p = "//static.m2.ru//search/9ef1c9ae/";